import { Controller } from 'stimulus'

export default class extends Controller {

  connect() {
    if (this.element.value != '') this.input()
  }

  input() {
    this.element.style.height = ''
    let borderBottom = parseInt(window.getComputedStyle(this.element).getPropertyValue('border-bottom-width'))
    let borderTop = parseInt(window.getComputedStyle(this.element).getPropertyValue('border-top-width'))
    this.element.style.height = `${ this.element.scrollHeight + borderBottom + borderTop }px`
  }
}
